import {Component, Input} from "@angular/core";

/**
 * A component that renders an SVG icon for "Tune"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: "app-icon-tune",
    templateUrl: "./icon-tune.component.html",
    styleUrls: ["./icon-tune.component.scss"],
    standalone: false
})
export class IconTuneComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
